var Header = {
    $el: $('.l-header'),

    data: {
        isSticky: false,
        windowWidth: 0,
        stickyBreakpoint: 50,
        scrollTop: 0,
    },

    init: function() {
        this.__initEventHandlers();
        this.__determineState({ type: 'initial' });
    },

    __initEventHandlers: function() {
        $(document).on('scroll', function(e) {
            Header.__determineState(e)
        });

        $(window).on('resize', function(e) {
            Header.__determineState(e);
        });
    },

    __determineState: function(e) {
        // Get essential data.
        this.data.scrollTop = $(window).scrollTop();
        this.data.windowWidth = $(window).width();

        // Fake "event"
        if ( this.__validEvent(e) && ( e.type === 'initial' || e.type === 'resize' ) ) {

            // Check if scroll distance from top is larger than sticky breakpoint.
            if ( this.data.scrollTop > this.data.stickyBreakpoint ) {
                // Then we set sticky.
                this.__setStickyState();
            } else if ( this.data.scrollTop <= this.data.stickyBreakpoint ) {
                // Else we unset sticky.
                this.__unsetStickyState();
            }

        }

        // Check if event type is scroll
        if ( this.__validEvent(e) && e.type === 'scroll' ) {
            // Check if scroll distance from top is larger than sticky breakpoint.
            if ( this.data.scrollTop > this.data.stickyBreakpoint && ! this.__isSticky() ) {
                // Then we set sticky.
                this.__setStickyState();
            } else if ( this.data.scrollTop <= this.data.stickyBreakpoint && this.__isSticky() ) {
                // Else we unset sticky.
                this.__unsetStickyState();
            }

        }
    },

    __updateHeightProperty: function () {
        document.documentElement.style.setProperty('--header-height', parseFloat(this.$el.outerHeight()));
        console.log('Updateheightproperty');
    },

    __setStickyState: function() {
        this.data.isSticky = true;
        this.$el.addClass('is-sticky');

        if ($('.m-productfeed__categories-bg').length > 0) {
            $('.m-productfeed__categories-bg').addClass('is-sticky');
        }
    },

    __unsetStickyState: function() {
        this.data.isSticky = false;
        this.$el.removeClass('is-sticky');

        if ($('.m-productfeed__categories-bg').length > 0) {
            $('.m-productfeed__categories-bg').removeClass('is-sticky');
        }
    },

    __isSticky: function() {
        return this.data.isSticky;
    },

    __validEvent: function(e) {
        return ( typeof e !== 'undefined' && typeof e.type !== 'undefined' );
    },
}

export default Header;



// WEBPACK FOOTER //
// ./scripts/layouts/header.js